import Vue from 'vue'
import Element from 'element-ui'
import '../element-variables.scss'
import 'element-ui/lib/theme-chalk/display.css'
import lang from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
locale.use(lang)
Vue.use(Element)

